var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: " mt-0 mb-0" }, [
      _c("div", { staticClass: "col-12 p-0" }, [
        _c("span", [
          _c("img", {
            staticClass: "img-fluid",
            attrs: {
              src:
                this.data.cover == null
                  ? "/images/cover.png"
                  : this.data.cover.url,
            },
          }),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pt-1 pb-1 col-12" }, [
          _c("a", { attrs: { href: "/video/" + this.data.slug } }, [
            _c("span", {
              staticClass: "h3",
              domProps: { textContent: _vm._s(this.data.title) },
            }),
          ]),
          _vm._v(" "),
          _c("div", [
            this.data.can_view_video === false
              ? _c(
                  "span",
                  { staticClass: "badge badge-pill bg-gradient-success" },
                  [
                    _c("i", { staticClass: "feather icon-award" }),
                    _vm._v(" " + _vm._s(_vm.__("globals.premium_only"))),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("span", { staticClass: "badge badge-pill badge-light" }, [
              _c("i", { staticClass: "fa fa-eye" }),
              _vm._v(" " + _vm._s(this.data.views) + " Views"),
            ]),
          ]),
          _vm._v(" "),
          _c("div", [
            _c(
              "div",
              {
                directives: [{ name: "linkified", rawName: "v-linkified" }],
                staticClass: "breakAll pt-1",
              },
              [
                _c("span", {
                  staticClass: "breakAll image-resize",
                  domProps: { innerHTML: _vm._s(this.data.description) },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "text-right" }, [
              _c(
                "a",
                {
                  staticClass: "font-small-3",
                  attrs: { href: "/video/" + this.data.slug },
                },
                [
                  _vm._v(_vm._s(_vm.__("globals.read_more"))),
                  _c("i", { staticClass: "feather icon-chevron-right" }),
                ]
              ),
            ]),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }